module.exports = __webpack_public_path__ + "img/logo-house-medium-6.a992ecbb.svg";